import React from "react";
import "./Pages.css";
export default function Ambientes() {
  return (
    <section className="titulo">
      <h2>Ambientes</h2>
      <div className="subtitulo">
        <p>Conheça os ambientes do nosso buffet infantil, com estrutura completa para festas inesquecíveis.</p>
      </div>
      <div className="img-container">
        <img loading="lazy" src="/images-webp/entradaBuffet.webp" alt="Entrada" />
        <img loading="lazy" src="/images-webp/entradaBuffet2.webp" alt="Entrada" />
        <img loading="lazy"src="/images-webp/entradaBuffet3.webp" alt="Entrada" />
        <img loading="lazy" src="/images-webp/Salão/recepcaoDecoracao.webp" alt="decoração recepção" />
        <img loading="lazy" src="/images-webp/Salão/recepcaoDecoracao2.webp" alt="decoração recepção" />
        <img loading="lazy" src="/images-webp/Salão/recepcaoDecoracao3.webp" alt="decoração recepção" />
        <img loading="lazy" src="/images-webp/Salão/cafeRecepcao.webp" alt="recepção" />
        <img loading="lazy" src="/images-webp/Salão/recepcao5.webp" alt="recepção" />
        <img loading="lazy" src="/images-webp/Salão/recepcao6.webp" alt="recepção" />
        <img loading="lazy" src="/images-webp/Salão/recepcao4.webp" alt="recepção" />
        <img loading="lazy" src="/images-webp/Salão/salao.webp" alt="salao principal" />                        
        <img loading="lazy" src="/images-webp/Salão/salaoPrincipal.webp" alt="salao principal" />
        <img loading="lazy" src="/images-webp/Salão/salao3.webp" alt="salao principal" />
        <img loading="lazy" src="/images-webp/Salão/salao4.webp" alt="salao principal" />
        <img loading="lazy" src="/images-webp/Salão/salao5.webp" alt="salao principal" />
        <img loading="lazy" src="/images-webp/Salão/salao6.webp" alt="salao principal" />
        <img loading="lazy" src="/images-webp/Salão/salao7.webp" alt="salao principal" />
        <img loading="lazy" src="/images-webp/Salão/salao8.webp" alt="salao principal" />
        <img loading="lazy" src="/images-webp/Salão/salao9.webp" alt="salao principal" />
        <img loading="lazy" src="/images-webp/Salão/areaKids.webp" alt="area kids" />
        <img loading="lazy" src="/images-webp/Salão/areaKids1.webp" alt="area kids" />
        <img loading="lazy" src="/images-webp/Salão/areaKids2.webp" alt="area kids" />
        <img loading="lazy" src="/images-webp/Salão/copa2.webp" alt="copa" />
        <img loading="lazy" src="/images-webp/Salão/copa.webp" alt="copa" />
        <img loading="lazy" src="/images-webp/Salão/copa3.webp" alt="copa" />
        <img loading="lazy" src="/images-webp/Salão/copa4.webp" alt="copa" />
        <img loading="lazy" src="/images-webp/Salão/copa5.webp" alt="copa" />
        <img loading="lazy" src="/images-webp/Salão/upSalao.webp" alt="salao de cima" />
        <img loading="lazy" src="/images-webp/Salão/upSalao2.webp" alt="salao de cima" />
        <img loading="lazy" src="/images-webp/Salão/upSalao3.webp" alt="salao de cima" />
        <img loading="lazy" src="/images-webp/Salão/upSalao4.webp" alt="salao de cima" />
      </div>
    </section>
  );
}
